<template>
    <div class="pdfThumbs" v-on:load="loadComponent">
        <div class="addFileDiv">
            <font-awesome-icon :icon="['fas', 'plus-circle' ]" class="addFileIcon" />
            <input v-on:change="loadPDF" type="file" class="addFile" />
        </div>
        <div class="selectFileDiv">
            <font-awesome-icon :icon="['fas', 'list-alt' ]" class="presentationSelectorIcon" />
            <select class="presentationSelector" v-model="currentPresentation">
                <option v-for="presentation in presentations" :key="presentation.id" :value="presentation">{{presentation.title}}</option>
            </select>
        </div>
        <div class="ThumbRow" v-for="presentation in presentations" :key="presentation.id" v-show="currentPresentation === presentation">
            <CanvasPage v-for="canvasPage in presentation.canvasPages" :key="canvasPage.id" :canvas="canvasPage.canvas" :id="canvasPage.id" :page="canvasPage.page" v-show="(canvasPage.page == presentation.page) || (canvasPage.page == presentation.page + 1) || (canvasPage.page == presentation.page - 1) || (canvasPage.page == 1) || (canvasPage.page == presentation.canvasPages.length)" :class="'container ' + (canvasPage.page == 1 ? ' first' : '') + (canvasPage.page == presentation.canvasPages.length ? ' last' : '') + (canvasPage.page == presentation.page ? ' current' : '') + (canvasPage.page == presentation.page - 1 ? ' previous' : '') + (canvasPage.page == presentation.page + 1 ? ' next' : '')" :data-page="canvasPage.page" :data-presentation="presentation.id" v-on:click.native="presentation.page = canvasPage.page;$emit('set-presentation-and-page', presentation.id, canvasPage.page);"></CanvasPage>
        </div>
        <!--        <font-awesome-icon v-on:click="page = 1; setPage();" :icon="['fas', 'fast-backward' ]" class="pageControl first" />
                <font-awesome-icon v-on:click="page -= 1; setPage();" :icon="['fas', 'caret-left' ]" class="pageControl previous" />
                <font-awesome-icon v-on:click="page += 1; setPage();" :icon="['fas', 'caret-right' ]" class="pageControl next" />
                <font-awesome-icon v-on:click="page = pages; setPage();" :icon="['fas', 'fast-forward' ]" class="pageControl last" />-->
    </div>
</template>

<script>
    import * as uniqueId from 'lodash.uniqueid';
    import * as pdfjsLib from 'pdfjs-dist/webpack';
    import CanvasPage from './CanvasPage.vue';


    //pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

    export default {
        name: 'PdfPreview',
        components: {
            CanvasPage,
        },
        props: {
            emitEvents: { type: Boolean, default: true },
        },
        data: function () {
            return {
                filename: String,
                state: String,
                pdfThumbs: [],
                page: Number,
                pages: Number,
                //                eventListeners: new Map(),
                currentPresentation: undefined,
                presentations: [],
            }
        },
        computed: {
            currentPresentationId: function () {
                if (this.currentPresentation) {
                    return this.currentPresentation.id;
                } else {
                    return undefined;
                }
            }
        },
        mounted: function () {
            document.addEventListener('keydown', function (event) {
                switch (event.key) {
                    case 'ArrowLeft':
                    case 'ArrowUp':
                    case 'PageUp':
                        if (this.currentPresentation && (this.currentPresentation.page > 1)) {
                            this.currentPresentation.page--;
                        }
                        event.preventDefault();
                        this.$emit('set-presentation-and-page', this.currentPresentation.id, this.currentPresentation.page);
                        break;
                    case 'ArrowRight':
                    case 'ArrowDown':
                    case 'PageDown':
                        if (this.currentPresentation && (this.currentPresentation.page < this.currentPresentation.canvasPages.length)) {
                            this.currentPresentation.page++;
                        }
                        this.$emit('set-presentation-and-page', this.currentPresentation.id, this.currentPresentation.page);
                        event.preventDefault();
                        break;
                    case 'Home':
                        if (this.currentPresentation) {
                            this.currentPresentation.page = 1;
                        }
                        this.$emit('set-presentation-and-page', this.currentPresentation.id, this.currentPresentation.page);
                        event.preventDefault();
                        break;
                    case 'End':
                        if (this.currentPresentation) {
                            this.currentPresentation.page = this.currentPresentation.canvasPages.length;
                        }
                        this.$emit('set-presentation-and-page', this.currentPresentation.id, this.currentPresentation.page);
                        event.preventDefault();
                        break;
                    default:
                }
            }.bind(this));
        },
        methods: {
            loadComponent: function () {
                this.state = "noFile";
                this.page = undefined;
            },
            loadPDF: function (event) {
                var self = this;
                if (event.target.files.length > 0) {
                    self.pdfThumbs = [];
                    self.page = undefined;
                    self.setPage();
                    this.state = "loading";
                    var file = event.target.files[0];
                    var fileReader = new FileReader();
                    fileReader.onload = function (filename) {
                        return function () {
                            var typedArray = new Uint8Array(this.result);
                            //var loadEvent = new Event('fileLoad');
                            //loadEvent.data = { type: 'application/pdf', file: this.result, id: uniqueId('presentation-') };
                            //self.dispatchEvent(loadEvent);
                            var presentationId = uniqueId('presentation-');
                            self.$emit('load-presentation', presentationId, 'application/pdf', this.result);
                            var presentation = { id: presentationId, type: 'application/pdf', canvasPages: [], page: 1, title: filename, fileData: this.result };
                            self.presentations.push(presentation);
                            var loadingTask = pdfjsLib.getDocument(typedArray);
                            loadingTask.promise.then(function (pdf) {
                                pdf.getMetadata().then(function (metaObj) {
                                    if (metaObj.info.Title) {
                                        var title = metaObj.info.Title.trim();
                                        if (title != "") {
                                            presentation.title = title;
                                        }
                                    }
                                });
                                self.pages = pdf.numPages;
                                self.currentPresentation = presentation;
                                for (var pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                                    var canvas = document.createElement("canvas");
                                    canvas.classList.add("pdfThumb");
                                    canvas.classList.add("page-" + pageNum);
                                    canvas.classList.add("page-last-" + (pdf.numPages - pageNum + 1));
                                    if (pageNum == 1) {
                                        canvas.classList.add("page-first");
                                    }
                                    if (pageNum == pdf.numPages) {
                                        canvas.classList.add("page-last");
                                    }
                                    canvas.setAttribute(self.$options._scopeId, "");
                                    self.pdfThumbs.push(canvas);
                                    //                                self.$el.querySelector(".ThumbRow .container.other").append(canvas);
                                    self.renderPage(pdf, pageNum, canvas);
                                    canvas.addEventListener("click", self.thumbClick);
                                    presentation.canvasPages.push({ id: uniqueId('CanvasPage-'), page: pageNum, canvas: canvas });
                                }
                                self.page = 1;
                                self.setPage();
                            });
                        };
                    }(file.name);
                    fileReader.readAsArrayBuffer(file);
                    event.target.value = null;
                }
            },
            renderPage: function (pdf, pageNum, canvas) {
                pdf.getPage(pageNum).then(function (page) {
                    var context = canvas.getContext("2d");
                    var viewport = page.getViewport({ scale: 1.0 });
                    var boxSize = 250 * window.devicePixelRatio;
                    var scale;
                    if (viewport.width < viewport.height) {
                        scale = boxSize / viewport.height;
                        canvas.width = boxSize / viewport.height * viewport.width;
                        canvas.height = boxSize;
                    } else {
                        scale = boxSize / viewport.width;
                        canvas.height = boxSize / viewport.width * viewport.height;
                        canvas.width = boxSize;
                    }
                    viewport = page.getViewport({ scale: scale });
                    var renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    page.render(renderContext);
                });
            },
            /*            thumbClick: function (event) {
                            var sel = this.$el.querySelector(".pdfThumb.current");
                            if (sel) {
                                sel.classList.remove("current");
                            }
                            sel = this.$el.querySelector(".pdfThumb.next");
                            if (sel) {
                                sel.classList.remove("next");
                            }
                            sel = this.$el.querySelector(".pdfThumb.previous");
                            if (sel) {
                                sel.classList.remove("previous");
                            }
                            event.target.classList.add("current");
                            sel = event.target.nextSibling;
                            if (sel) {
                                sel.classList.add("next");
                            }
                            sel = event.target.previousSibling;
                            if (sel) {
                                sel.classList.add("previous");
                            }
                        },*/
            setPage: function () {
                /*                this.$el.querySelector(".ThumbRow .container.first").textContent = "";
                                this.$el.querySelector(".ThumbRow .container.previous").textContent = "";
                                this.$el.querySelector(".ThumbRow .container.current").textContent = "";
                                this.$el.querySelector(".ThumbRow .container.next").textContent = "";
                                this.$el.querySelector(".ThumbRow .container.last").textContent = "";*/
                if (this.page === undefined) {
                    return;
                }
                if (this.page < 1) {
                    this.page = 1;
                }
                if (this.page > this.pages) {
                    this.page = this.pages;
                }
                this.$emit('set-page', this.page);
                //var pageEvent = new Event('setPage');
                //pageEvent.data = this.page;
                //this.dispatchEvent(pageEvent);
                /*                if (this.page > 2) {
                                    this.$el.querySelector(".ThumbRow .container.first").appendChild(this.pdfThumbs[0]);
                                }
                                if (this.page < this.pages - 1) {
                                    this.$el.querySelector(".ThumbRow .container.last").appendChild(this.pdfThumbs[this.pages - 1]);
                                }
                                if (this.page > 1) {
                                    this.$el.querySelector(".ThumbRow .container.previous").appendChild(this.pdfThumbs[this.page - 2]);
                                }
                                if (this.page < this.pages) {
                                    this.$el.querySelector(".ThumbRow .container.next").appendChild(this.pdfThumbs[this.page]);
                                }
                                if (this.page > 0) {
                                    this.$el.querySelector(".ThumbRow .container.current").appendChild(this.pdfThumbs[this.page - 1]);
                                }*/
            },
        },
        watch: {
            emitEvents: function (emitEvents) {
                if (emitEvents) {
                    setTimeout(function () {
                        this.presentations.forEach(presentation => {
                            this.$emit('load-presentation', presentation.id, presentation.type, presentation.fileData);
                        }, this);
                        if (this.currentPresentation) {
                            this.$emit('set-presentation-and-page', this.currentPresentation.id, this.currentPresentation.page);
                        }
                    }.bind(this), 1500);
                }
            },
            currentPresentation: function (presentation) {
                if (presentation) {
                    this.$emit('set-presentation-and-page', presentation.id, presentation.page);
                }
            }
        },
    };
</script>

<style scoped>
    .pdfThumbs {
        display: grid;
        align-items: center;
        justify-items: center;
        grid-template-rows: 3rem 3rem 1fr;
        grid-template-columns: 3rem 1fr;
        grid-template-areas:
            "addFile thumbRow"
            "selectFile thumbRow"
            "none thumbRow";
        /*margin: 8px;*/
    }

    .ThumbRow {
        grid-area: thumbRow;
        display: grid;
        align-items: end;
        justify-items: center;
        grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr;
        grid-template-areas:
            ". . currentThumb . ."
            "firstThumb previousThumb currentThumb nextThumb lastThumb"
            "firstThumb previousThumb currentThumb nextThumb lastThumb";
        grid-column-gap: .5rem;
        height: 100%;
        width: 100%;
    }

        .ThumbRow .container {
            font-size: 3rem;
            text-align: center;
            vertical-align: middle;
        }

        .ThumbRow .pageControl {
            font-size: 3rem;
        }

        .ThumbRow .container.first:not(.previous):not(.current) {
            /*margin-right: 1.5rem;*/
            grid-area: firstThumb;
        }

        .ThumbRow .container.first .pdfThumb,
        .ThumbRow .container.last .pdfThumb {
            border: .25rem #aaaaaa;
            border-style: none solid;
        }

        .ThumbRow .pageControl.first {
            grid-area: firstControl;
            margin-right: 1.5rem;
        }

    .pdfThumbs .selectFileDiv {
        grid-area: selectFile;
        width: 100%;
        height: 100%;
    }

        .pdfThumbs .selectFileDiv .presentationSelector {
            width: 100%;
            height: 100%;
            font-size: 2rem;
            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;
            border: none;
            color: #00000000;
            outline: none;
            background-color: #00000000;
            position: relative;
            top: -100%;
            z-index: 10;
        }

            .pdfThumbs .selectFileDiv .presentationSelector::-ms-expand {
                display: none;
            }

            .pdfThumbs .selectFileDiv .presentationSelector option {
                font-size: 2rem;
                color: #000000;
                padding: 0.5rem;
            }

    .pdfThumbs .addFileDiv {
        grid-area: addFile;
        width: 100%;
        height: 100%;
    }

        .pdfThumbs .addFileDiv .addFile {
            /*justify-self: center;*/
            /*align-self: center;*/
            width: 100%;
            height: 100%;
            position: relative;
            top: -100%;
            z-index: 10;
            opacity: 0;
        }

        .pdfThumbs .addFileDiv .addFileIcon {
            font-size: 3rem;
        }

    .pdfThumbs .selectFileDiv .presentationSelectorIcon {
        font-size: 3rem;
    }

    .ThumbRow .container.next {
        grid-area: nextThumb;
    }

    .ThumbRow .pageControl.next {
        grid-area: nextControl;
    }

    .ThumbRow .container.previous {
        grid-area: previousThumb;
    }

    .ThumbRow .pageControl.previous {
        grid-area: previousControl;
    }

    .ThumbRow .container.last:not(.next):not(.current) {
        /*margin-left: 1.5rem;*/
        grid-area: lastThumb;
    }

    .ThumbRow .pageControl.last {
        margin-left: 1.5rem;
        grid-area: lastControl;
    }

    .ThumbRow .container.current {
        grid-row-end: span 2;
        grid-area: currentThumb;
    }

    .ThumbRow .container .pdfThumb {
        outline: 1px solid black;
        max-width: 100%;
        max-height: 100%;
    }

    .ThumbRow .container {
        display: flex;
        align-items: flex-end;
        justify-content: center;
    }
</style>
